import { BitkitLink, BitkitOverflowTooltip } from '@bitrise/bitkit-v2';
import { Text, TextProps } from '@chakra-ui/react/text';

import useIsTruncated from '@/hooks/useIsTruncated';
import { PublicApiApp } from '@/models/App';

type AppTitleProps = { app: Pick<PublicApiApp, 'title'>; href?: string } & TextProps;

const AppTitle = ({ app, color = 'text/primary', href, ...rest }: AppTitleProps) => {
  const { ref, isTruncated } = useIsTruncated<HTMLAnchorElement & HTMLSpanElement>();

  return (
    <BitkitOverflowTooltip disabled={!isTruncated} text={app.title}>
      <Text asChild color={color} textStyle="body/lg/semibold" truncate {...rest}>
        {href ? (
          <BitkitLink href={href} ref={ref}>
            {app.title}
          </BitkitLink>
        ) : (
          <span ref={ref}>{app.title}</span>
        )}
      </Text>
    </BitkitOverflowTooltip>
  );
};

export default AppTitle;
